module.exports = __webpack_public_path__ + "images/emoji/no_bicycles.a873d4492c445fd0fc21.png";